import { render, staticRenderFns } from "./diyguide.vue?vue&type=template&id=32bf9b68&scoped=true&"
import script from "./diyguide.vue?vue&type=script&lang=js&"
export * from "./diyguide.vue?vue&type=script&lang=js&"
import style0 from "./diyguide.vue?vue&type=style&index=0&id=32bf9b68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bf9b68",
  null
  
)

export default component.exports